'use client';

import { _ as _extends } from './cc-he3fHS3P.js';
import { jsx } from 'react/jsx-runtime';
import { useTheme } from 'next-themes';
import { Toaster as Toaster$1 } from 'sonner';
const Toaster = _0 => {
  const props = _extends({}, _0);
  const {
    theme: t0
  } = useTheme();
  const theme = t0 === undefined ? "system" : t0;
  return jsx(Toaster$1, _extends({
    theme,
    className: "toaster group",
    style: {
      "--normal-bg": "var(--popover)",
      "--normal-text": "var(--popover-foreground)",
      "--normal-border": "var(--border)",
      "--success-bg": "var(--popover)",
      "--success-text": "var(--popover-foreground)",
      "--error-bg": "var(--popover)",
      "--error-text": "var(--popover-foreground)",
      "--warning-bg": "var(--popover)",
      "--warning-text": "var(--popover-foreground)"
    }
  }, props));
};
export { Toaster };